export const DEL_CART_ITEM = 'DEL_CART_ITEM';

/**
 * This action is used to remove items from the cart state
 * @param {string} lineItemId The lineItemId to delete from the cart
 * @param {number} quantity The quantity to reduce from the cart
 * @returns An action object of the specified type and payload
 */

const delCartItem = (lineItemId) => {
    return {
        type: DEL_CART_ITEM,
        payload: {
            lineItemId,
        },
    };
};

export default delCartItem;